import React from 'react';

const Scroll  = (props) =>{
	console.log(props);
	// return props.children
	return(
		<div style = {{overflowY: 'scroll', border:'5px solid black',height:'360px' }}>
			{props.children}
		</div>
	);
};

export default Scroll;